export default {
  version: 'master',
  compilation: '281895'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1477
// module chunks = 22